import { RouteUser as CaseTemplateRoute } from './CaseTemplate/List';
import { Route as PageTemplateRoute } from './Pages/List';
import { Route as ReportTemplateRoute } from './ReportTemplates/List';

export default [CaseTemplateRoute, PageTemplateRoute, ReportTemplateRoute];
